import { Component, OnInit,Input, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';


@Component({
  selector: 'app-activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.scss'],
})
export class ActivityLogComponent implements OnInit {

    
    @Input() activity_log: any = null;
    @Input() table: any = '';
    @Input() guid: any = '';
    current_user: any = null;
  
  
    constructor(public globalService: GlobalService, private apiService: ApiService) { }
  
    ngOnInit() {
      this.current_user = this.globalService.GetCurrentUser();
      this.GetData();
    }

    async GetData() {
      let data: any = await this.apiService.get(`activity_log/${this.table}/${this.guid}`);
      if(data.success) this.activity_log = data.data;
      else this.activity_log = [];
    }


}
